/* eslint-disable @typescript-eslint/no-explicit-any */

import classNames from 'classnames';
import { Moment } from 'moment';
import React, { ReactNode } from 'react';

import { HeaderLayout } from './Header';

import './style.scss';

interface IProps {
    className?: string;
    children?: ReactNode;
    title: string;
    actionHeader?: IActionButton[];
    actionFooter?: IActionButton[];
    isBack?: boolean;
    isImport?: boolean;
    multipleStore?: boolean;
    api?: string;
    storeName?: string;
    dateFilter?: string;
    onHandleModal?: () => void;
    actionFilter?: IActionDateFilter;
}

interface IActionButton {
    title: string;
    url: string;
    icon?: React.ReactNode;
    exportCsv?: (data?: any) => void;
}

interface IActionDateFilter {
    title?: string;
    value: Moment;
    onChange?: (data?: any) => void;
}

const LayoutContent: React.FC<IProps> = ({
    title,
    children,
    className,
    actionHeader,
    actionFooter,
    isBack,
    isImport,
    multipleStore,
    api,
    storeName,
    dateFilter,
    onHandleModal,
    actionFilter,
}) => {
    return (
        <>
            <HeaderLayout
                onHandleModal={onHandleModal}
                isImport={isImport}
                multipleStore={multipleStore}
                api={api}
                isBack={isBack}
                title={title}
                actions={actionHeader}
                storeName={storeName}
                dateFilter={dateFilter}
                actionFilter={actionFilter}
            />
            <div className={classNames('l-content__wrap', `${className}`)}>{children}</div>
        </>
    );
};

export default React.memo(LayoutContent);
